import { ReactNode } from 'react'

export interface ToggleOption {
  value: string
  label: string
  icon: ReactNode
}

export default function ToggleOptionList({
  options,
  value,
  onChange,
}: {
  options: ToggleOption[]
  value: string
  onChange: (value: string) => void
}) {
  return (
    <div className="space-y-1">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors cursor-pointer ${
            value === option.value
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          <span className="text-lg flex-shrink-0">{option.icon}</span>
          <span className={`text-sm ${value === option.value ? 'font-medium' : ''}`}>
            {option.label}
          </span>
        </button>
      ))}
    </div>
  )
}
